var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnakeBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 88,
    viewBox: "0 0 125 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.167 5.02105C125.653 8.1254 125.185 12.8174 121.498 14.3068C115.885 16.5742 110.715 15.9967 106.652 15.546C101.702 14.997 99.38 14.853 96.23 17.373C93.089 19.893 92.711 22.188 92.171 27.147C91.568 32.664 90.74 40.224 82.802 46.587C74.864 52.95 67.304 52.104 61.787 51.492C56.837 50.943 54.515 50.799 51.365 53.319C48.224 55.839 47.846 58.134 47.306 63.084C46.703 68.601 45.875 76.161 37.937 82.524C29.999 88.887 22.439 88.041 16.922 87.429C15.4803 87.2691 14.2614 87.1436 13.1802 87.1082C9.20503 86.9782 4.48538 86.7398 1.99958 83.635C-0.485888 80.5307 -0.0183518 75.8387 3.66894 74.3492C9.28222 72.0818 14.4525 72.6594 18.515 73.11C23.465 73.659 25.787 73.803 28.937 71.283C32.078 68.763 32.456 66.468 32.996 61.518C33.599 56.001 34.427 48.441 42.365 42.078C50.303 35.715 57.863 36.561 63.38 37.173C68.33 37.722 70.652 37.866 73.802 35.346C76.952 32.826 77.321 30.531 77.861 25.572C78.464 20.055 79.292 12.495 87.23 6.13202C95.168 -0.230976 102.728 0.615027 108.245 1.22703C109.687 1.38693 110.906 1.51248 111.987 1.54785C115.962 1.67788 120.682 1.91629 123.167 5.02105Z",
    fill: "#15DCFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnakeBlue);
export default __webpack_public_path__ + "static/media/snake-blue.2d626e67b3750294f7330e8bd9119051.svg";
export { ForwardRef as ReactComponent };